// extracted by mini-css-extract-plugin
module.exports = {"QuickNavTrigger":"QuickNavTrigger-module--QuickNavTrigger--y8Njm"};